import { ControlUnitAPIResponse } from '../../../redux/controlUnit/api/ControlUnit.model';
import ControlUnitAPI from '../../../redux/controlUnit/api/ControlUnitAPI';
import {
  getControlUnitsActiveByIdFilter,
  getControlUnitsVisibleByIdFilter,
} from '../../../redux/controlUnit/selectors';
import { Merchandiser } from '../redux/composableDevice/model/Merchandiser.model';

export const useGetValidControlUnits = (merchandiser: Merchandiser) => {
  const { data: controlUnits } = ControlUnitAPI.useGetControlUnitByIdQuery(
    merchandiser?.deviceId,
    {}
  );
  const validControlUnits =
    Object.values(controlUnits?.entities || {})
      .filter((cu) => cu !== undefined)
      .filter(
        (cu: ControlUnitAPIResponse) =>
          getControlUnitsActiveByIdFilter(cu) &&
          getControlUnitsVisibleByIdFilter(cu)
      ) || [];
  return validControlUnits;
};
